<h2 mat-dialog-title>{{ data.title }}</h2>
<div mat-dialog-content data-folders>
  <app-select-folder
    #picker
    [config]="data.config"
    [createFolder$]="createFolder$.asObservable()"
    [multiSelect]="true"
    (selectionChange)="selectionChanged($event)"
  />
</div>
<div mat-dialog-actions>
  <div class="status">
    <span class="count">{{ selected.length }} selected</span>
    @if (selected.length > 0) {
      <button mat-button color="primary" (click)="picker.clearSelection()">Deselect all</button>
    }
  </div>
  <button mat-button [mat-dialog-close]="">Close</button>
  <button mat-flat-button color="primary" (click)="select()" [disabled]="selected.length === 0">
    Select
  </button>
</div>
